// Registro de las terminales de las piezas (p. ej. el «teléfono» de un módulo Bluetooth): junta lo
// que mandan en cada cuadro aunque la pieza no esté seleccionada.
const MAX = 20000;

export function setupTerminals(app) {
  const logs = new Map(); // id → { text, decoder }
  app.terminals = {
    get(id) {
      return logs.get(id)?.text || '';
    },
    append(id, text) {
      let e = logs.get(id);
      if (!e) {
        e = { text: '', decoder: new TextDecoder('utf-8') };
        logs.set(id, e);
      }
      e.text = (e.text + text).slice(-MAX);
      app.emit('terminal', { id, text });
    },
  };
  app.on('frame', (f) => {
    if (!f) return;
    for (const [id, v] of f.visuals) {
      if (!v || !v.rx || !v.rx.length) continue;
      let e = logs.get(id);
      if (!e) {
        e = { text: '', decoder: new TextDecoder('utf-8') };
        logs.set(id, e);
      }
      app.terminals.append(id, e.decoder.decode(new Uint8Array(v.rx), { stream: true }));
    }
  });
  app.on('serial-reset', () => {
    logs.clear();
    app.emit('terminal', { id: null });
  });
  app.on('project-loaded', () => logs.clear());
}
